import { AiService } from "@/services";
export default {
  // -------------- 获取模型配置-------------
  async getModelSetting({ commit }) {
    const result = await AiService.getModelSetting();
    return result;
  },

  // -------------- 获取用户历史记录-------------
  async getUserHistory({ commit }, params) {
    const result = await AiService.getUserHistory(
      params.userId,
      params.is_all,
      params.tool_name,
      params.get_type,
      params.target_email,
      params.admin_query_type,
      params.admin_query_value
    );
    return result;
  },

  // -------------- 归档用户历史记录-------------
  async setUserHistory({ commit }, params) {
    const result = await AiService.setUserHistory(params.id,params.set_type);
    return result;
  },

  // -------------- 获取任务状态(支持单个和批量)-------------
  async getTaskStatus({ commit }, params) {
    const result = await AiService.getTaskStatus(params.ids, params.userId);
    return result;
  },
};
